import { FeatureFlagMap, ChannelFeatures, FeatureFlagsEnum } from '../../types/blp-feature-flags';
import { FeatureFlagsActions, SET_FEATURE_FLAGS, TOGGLE_FEATURE_FLAG } from '../actions/blp-feature-flags';

const isProd = process.env.REACT_APP_STAGE === 'prod';

export interface IFeatureFlagsReducer {
	featureFlags: FeatureFlagMap;
	channelFeatures: ChannelFeatures;
	loading: boolean;
}

export const initialFeatureFlagsState: IFeatureFlagsReducer = {
	channelFeatures: {},
	featureFlags: {},
	loading: true,
};

// eslint-disable-next-line function-paren-newline
export default function FeatureFlagsReducer(
	// eslint-disable-next-line default-param-last
	state = initialFeatureFlagsState, action: FeatureFlagsActions): IFeatureFlagsReducer {
	switch (action.type) {
		case SET_FEATURE_FLAGS: {
			return {
				...state,
				featureFlags: action.payload,
				loading: false,
			};
		}
		case TOGGLE_FEATURE_FLAG: {
			// do not allow this reducer to do anything in production.
			if (isProd) {
				return state;
			}

			return {
				...state,
				featureFlags: {
					...state.featureFlags,
					[action.payload as FeatureFlagsEnum]: !state.featureFlags[action.payload],
				},
			};
		}

		default: return state;
	}
}
